import React from "react";
import { PenLine } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { SIX_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createPs, createPsVersion, getPsAssets, updatePsMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: P.S. authoring (PS-SPEC-001). Live authoring uses
// current governed semantics only -- the historical PS0003 -> PS0001 drift
// noted in prior checkpoints is not revisited or exposed here.
const config = {
  familyCode: "PS",
  testIdPrefix: "ps",
  idField: "ps_id",
  contentField: "canonical_ps",
  contentLabel: "Canonical P.S.",
  contentInputType: "textarea",
  contentPlaceholder: "e.g. P.S. Rates go up with age -- lock yours in today.",
  labelSingular: "P.S.",
  labelPlural: "P.S.",
  icon: PenLine,
  statusValues: SIX_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable P.S. line (PS####).",
  api: {
    list: getPsAssets,
    create: ({ name, status, content }) => createPs({ name, status, canonicalPs: content }),
    createVersion: (id, { version, content }) => createPsVersion(id, { version, canonicalPs: content }),
    updateMetadata: (id, { name, status }) => updatePsMetadata(id, { name, status }),
  },
};

export default function PsPanel() {
  return <AssetFamilyPanel config={config} />;
}
